// Hydra Identifiers for PCLS
export const CONTROL_LEFT_IN_STOCK_4 = 0;
export const N_LEFT_IN_STOCK_4 = 1;
export const N_LEFT_IN_STOCK_10 = 2;
